'use strict';

module.exports = function isIos(userAgent) {
  userAgent = userAgent || navigator.userAgent;
  return /(iPad|iPhone|iPod)/i.test(userAgent);
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web/lib/is-ios.js
// module id = 540
// module chunks = 1